<template>
  <div class="bb-toast-container">
    <transition-group name="bb-toast-list">
      <div
        v-for="toast in toasts"
        :key="toast.id"
        :class="['bb-toast', `bb-toast-${toast.type}`]"
        role="alert"
      >
        <div class="bb-toast-icon" v-if="toast.type === 'success'">
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
        </div>
        <div class="bb-toast-icon" v-else-if="toast.type === 'error'">
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
        </div>
        <div class="bb-toast-icon" v-else-if="toast.type === 'warning'">
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path><line x1="12" y1="9" x2="12" y2="13"></line><line x1="12" y1="17" x2="12.01" y2="17"></line></svg>
        </div>
        <div class="bb-toast-icon" v-else>
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg>
        </div>
        <div class="bb-toast-body">
          <p class="bb-toast-title">{{ toast.message }}</p>
        </div>
        <button
          class="bb-toast-close"
          @click="removeToast(toast.id)"
          aria-label="Chiudi"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
        </button>
      </div>
    </transition-group>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { toastService } from '@/services/toastService'

const toasts = computed(() => toastService.getToasts())

const removeToast = (id) => {
  toastService.remove(id)
}
</script>

<style scoped>
.bb-toast-container {
  position: fixed;
  bottom: 24px;
  right: 24px;
  z-index: 999999;
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: auto;
  max-width: 360px;
  pointer-events: none;
}

.bb-toast {
  pointer-events: auto;
  display: flex !important;
  align-items: flex-start;
  gap: 12px;
  padding: 14px 14px 14px 16px;
  border-radius: 10px;
  background: #ffffff;
  box-shadow:
    0 1px 2px rgba(0,0,0,0.04),
    0 8px 28px -6px rgba(0,0,0,0.22);
  border-left: 4px solid var(--dark-teal);
  transition: all 0.3s ease;
}

.bb-toast-success {
  border-left-color: var(--dark-teal);
}

.bb-toast-error {
  border-left-color: var(--danger);
}

.bb-toast-warning {
  border-left-color: #f4d03f;
}

.bb-toast-info {
  border-left-color: var(--teal);
}

.bb-toast-icon {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: #ffffff;
}

.bb-toast-success .bb-toast-icon {
  background: var(--dark-teal);
}

.bb-toast-error .bb-toast-icon {
  background: var(--danger);
}

.bb-toast-warning .bb-toast-icon {
  background: #f4d03f;
  color: #000;
}

.bb-toast-info .bb-toast-icon {
  background: var(--teal);
}

.bb-toast-body {
  flex: 1;
  min-width: 0;
}

.bb-toast-title {
  font-family: 'Montserrat', sans-serif;
  font-size: 13px;
  font-weight: 700;
  color: #000000;
  margin: 0;
  line-height: 1.3;
}

.bb-toast-close {
  background: none;
  border: none;
  color: #999999;
  opacity: 0.6;
  cursor: pointer;
  padding: 2px;
  margin-left: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.2s, color 0.2s;
  flex-shrink: 0;
  line-height: 0;
}

.bb-toast-close:hover {
  opacity: 1;
  color: #333333;
}

/* Animazioni */
.bb-toast-list-enter-active {
  animation: bb-slideInRight 0.35s cubic-bezier(0.16,1,0.3,1);
}

.bb-toast-list-leave-active {
  animation: bb-fadeOut 0.3s ease-in forwards;
}

@keyframes bb-slideInRight {
  from {
    transform: translateX(24px);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

@keyframes bb-fadeOut {
  from {
    opacity: 1;
    transform: translateX(0);
  }
  to {
    opacity: 0;
    transform: translateX(12px);
  }
}

@media (max-width: 768px) {
  .bb-toast-container {
    bottom: 20px;
    right: 20px;
    left: 20px;
    max-width: none;
  }
  
  .bb-toast {
    min-width: 0;
  }
}
</style>
